import type { LinkDetail } from '@/components/shared/link-widget'

export function normalizeUrlPath(urlPath: string): string {
    let normalisedUrl: string = urlPath.split(/[?#]/)[0] // remove query param & hash

    if (/^\//.test(normalisedUrl)) {
        // begins with forward slash
        normalisedUrl = normalisedUrl.substring(1)
    }
    if (/\/$/.test(normalisedUrl)) {
        // ends with forward slash
        normalisedUrl = normalisedUrl.slice(0, -1)
    }

    return normalisedUrl.toLowerCase()
}

export function getFilteredOtherCategoryLinks(options: {
    allLinks: LinkDetail[]
    excludedUrl: string | undefined
}): LinkDetail[] {
    const { allLinks, excludedUrl } = options
    if (!excludedUrl) {
        return allLinks
    }

    const normalizedExcludedUrl: string = normalizeUrlPath(excludedUrl)
    return allLinks.filter(({ url }) => normalizeUrlPath(url) !== normalizedExcludedUrl)
}
